module.exports = __webpack_public_path__ + "assets/img/xxyl_title.6c1c20b4.png";